export const APIS = {
  LoginUser: 'shop/login',
  getShop: 'shop',
  getShopMe: 'shop/me',
  getRedemptionShop: 'redemption-shop',
  getShopMeReward: '/shop/me/reward',
};

export const HOST = {
  localUrl:
    process.env.REACT_APP_API_BASE_URL,
  productionUrl:
    process.env.REACT_APP_API_BASE_URL,
};
